import { render, staticRenderFns } from "./Mase.vue?vue&type=template&id=2b30edb1&scoped=true&"
import script from "./Mase.vue?vue&type=script&lang=js&"
export * from "./Mase.vue?vue&type=script&lang=js&"
import style0 from "./Mase.vue?vue&type=style&index=0&id=2b30edb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30edb1",
  null
  
)

export default component.exports